import { useTranslation } from 'react-i18next';

import { ElectricalProjectImage } from '@/components/electrical-project-image';

import type { TechnicalDrawing } from '../utils/drawing-types';

import { DrawingDeleteButton } from './drawing-delete-button';
import { DrawingEditModal } from './drawing-edit-modal';

export type DrawingItemProps = {
    technicalDrawing: TechnicalDrawing;
    electricalProjectVersionId: string;
};

export function DrawingItem({ technicalDrawing, electricalProjectVersionId }: DrawingItemProps) {
    const { t } = useTranslation('applications');

    return (
        <div className="flex gap-4 items-start">
            <div className="flex-shrink-0 w-24 h-24">
                <ElectricalProjectImage
                    className="w-full h-full object-contain rounded-lg"
                    query={{
                        ElectricalProjectFileId: technicalDrawing.ElectricalProjectFileId,
                    }}
                    alt={t('drawings.item.image.alt')}
                    expandable
                />
            </div>
            <div className="flex-1 min-w-0">
                <table className="w-full">
                    <tbody>
                        <tr>
                            <td className="text-text-primary font-medium pr-2 whitespace-nowrap align-top w-28">Naam/nummer</td>
                            <td className="text-text-secondary truncate max-w-xs">{technicalDrawing.Name ?? '-'}</td>
                        </tr>
                        <tr>
                            <td className="text-text-primary font-medium pr-2 whitespace-nowrap align-top w-28">Waar te vinden</td>
                            <td className="text-text-secondary truncate max-w-xs">{technicalDrawing.Location ?? '-'}</td>
                        </tr>
                        <tr>
                            <td className="text-text-primary font-medium pr-2 whitespace-nowrap align-top w-28">Omschrijving</td>
                            <td className="text-text-secondary">{technicalDrawing.Description ?? '-'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="flex gap-2 flex-shrink-0">
                <DrawingDeleteButton
                    technicalDrawing={technicalDrawing}
                    electricalProjectVersionId={electricalProjectVersionId}
                />
                <DrawingEditModal
                    technicalDrawing={technicalDrawing}
                    electricalProjectVersionId={electricalProjectVersionId}
                />
            </div>
        </div>
    );
}
